import {
  ANALYTICAL_ACCOUNTS_LIST,
  ANALYTICAL_ACCOUNTS_LIST_SUCCESS,
  ANALYTICAL_ACCOUNTS_LIST_ERROR,
  ANALYTICAL_ACCOUNTS_NEW,
  ANALYTICAL_ACCOUNTS_NEW_SUCCESS,
  ANALYTICAL_ACCOUNTS_NEW_ERROR,
  ANALYTICAL_ACCOUNTS_EDIT,
  ANALYTICAL_ACCOUNTS_DELETE,
  ANALYTICAL_ACCOUNTS_DELETE_SUCCESS,
  ANALYTICAL_ACCOUNTS_DELETE_ERROR,
} from "./actionTypes"


export const analyticalAccountsList = data => ({
  type: ANALYTICAL_ACCOUNTS_LIST,
  payload: data
});

export const analyticalAccountsListSuccess = data => ({
  type: ANALYTICAL_ACCOUNTS_LIST_SUCCESS,
  payload: {data}
});

export const analyticalAccountsListError = error => ({
  type: ANALYTICAL_ACCOUNTS_LIST_ERROR,
  payload: error
});

export const analyticalAccountsNew = data => ({
  type: ANALYTICAL_ACCOUNTS_NEW,
  payload: data
});

export const analyticalAccountsNewSuccess = data => ({
  type: ANALYTICAL_ACCOUNTS_NEW_SUCCESS,
  payload: {data}
});

export const analyticalAccountsNewError = error => ({
  type: ANALYTICAL_ACCOUNTS_NEW_ERROR,
  payload: error
});

export const analyticalAccountsEdit = data => ({
  type: ANALYTICAL_ACCOUNTS_EDIT,
  payload: data
});

export const analyticalAccountsDelete = data => ({
  type: ANALYTICAL_ACCOUNTS_DELETE,
  payload: data
});

export const analyticalAccountsDeleteSuccess = data => ({
  type: ANALYTICAL_ACCOUNTS_DELETE_SUCCESS,
  payload: {data}
});

export const analyticalAccountsDeleteError = error => ({
  type: ANALYTICAL_ACCOUNTS_DELETE_ERROR,
  payload: error
});
